import { render } from "./device.vue?vue&type=template&id=7ef8ba72&scoped=true"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"

import "./device.vue?vue&type=style&index=0&id=7ef8ba72&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ef8ba72"

export default script